import { get, post, put } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';
export const CART_SORT = 'CART_SORT';

export const load = () => (dispatch) => {
    return get('/api/cart')
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: { error }
})

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart,
})

export const toggle = open => (dispatch, getState) => {
    const shouldOpen = typeof open === 'undefined' ?
        !getState().cart.showInfo :
        open;
    dispatch(show(shouldOpen));
}

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

export const onSort = sortCriteria => (dispatch) => {
    sessionStorage.setItem("cartSort", sortCriteria)
    dispatch(sort(sortCriteria))
}

const sort = sortCriteria => ({
    type: CART_SORT,
    payload: {
        selectedSort: sortCriteria
    }
})

export function sortList(selectedSort, list) {
    var sort = sessionStorage.getItem("cartSort") || selectedSort
    if (sort === 'DeliveryWeek') {
        return list.map(a=> {return a}).sort((a,b) => a.stockStatusDescription > b.stockStatusDescription && 1 || -1)
    }
    else if (sort === 'ArticleNumber') {
        return list.map(a=> {return a}).sort((a,b) => a.articleNumber > b.articleNumber && 1 || -1)
    }
    else if (sort === 'Name') {
        return list.map(a=> {return a}).sort((a,b) => a.name > b.name && 1 || -1)
    }
    return list
}

export function add({ articleNumber, quantity = 1 }) {
    return (dispatch) => {

        const catnav = document.querySelector('.product__category');
        if (catnav && window.__litium.requestContext.productCategorySystemId) {
            get('/api/klevu/catnav?cat=' + window.__litium.requestContext.productCategorySystemId + "&v=" + articleNumber);
        }
        const query = document.querySelector('.query');
        if (query){
            get('/api/klevu/quicksearch?v=' + articleNumber + "&q=" + encodeURIComponent(query.innerHTML));
        }

        return post('/api/cart/add', { articleNumber, quantity })
            .then(response => response.json())
            .then(cart => {
                if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                    gtag('event', cart.event, cart.dataLayer);
                }
                dispatch(receive(cart));
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))))
            ;
    }
}

export function reorder({ orderid }) {
    if (orderid) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderid })
                .then(response => response.json())
                .then(cart => {
                    if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null){
                        gtag('event',cart.event,cart.dataLayer);
                    }
                    dispatch(receive(cart));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))));
        }
    }
}

export const update = (rowSystemId, quantity) => (dispatch) => {
    return put(`/api/cart/update`, { rowSystemId, quantity })
        .then(response => response.json())
        .then(cart => {
            if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                gtag('event', cart.event, cart.dataLayer);
            }
            dispatch(receive(cart));
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}